var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvailableCourses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.4 43.433A6.988 6.988 0 0 0 52 31.08V6a6.006 6.006 0 0 0-6-6H10a6.006 6.006 0 0 0-6 6v36.019A9.993 9.993 0 1 0 19.949 51H42v6a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-7a7.007 7.007 0 0 0-4.6-6.567zM56 38a5 5 0 0 1-4.99 5h-.02A5 5 0 1 1 56 38zM10 2h36a4 4 0 0 1 4 4v6H6V6a4 4 0 0 1 4-4zM6 14h44v17.08a6.988 6.988 0 0 0-3.4 12.353A7.012 7.012 0 0 0 42.08 49H19.949A9.987 9.987 0 0 0 6 40.841zm4 44a8 8 0 1 1 8-8 8.009 8.009 0 0 1-8 8zm48-1a1 1 0 0 1-2 0v-7a1 1 0 0 0-2 0v7c.003.341.066.68.184 1h-6.368c.118-.32.18-.659.184-1v-7a1 1 0 0 0-2 0v7a1 1 0 0 1-2 0v-7a5.006 5.006 0 0 1 5-5h4a5.006 5.006 0 0 1 5 5z",
    fill: "#81A63D",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0-4a1 1 0 1 1 0 2 1 1 0 0 1 0-2zM12 22a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0-4a1 1 0 1 1 0 2 1 1 0 0 1 0-2zM19 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0-4a1 1 0 1 1 0 2 1 1 0 0 1 0-2zM27 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0-4a1 1 0 1 1 0 2 1 1 0 0 1 0-2zM39 10h6a3 3 0 0 0 0-6h-6a3 3 0 0 0 0 6zm0-4h6a1 1 0 0 1 0 2h-6a1 1 0 0 1 0-2zM19 20h27a1 1 0 0 0 0-2H19a1 1 0 0 0 0 2zM12 30a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0-4a1 1 0 1 1 0 2 1 1 0 0 1 0-2zM19 28h27a1 1 0 0 0 0-2H19a1 1 0 0 0 0 2zM15 35a3 3 0 1 0-6 0 3 3 0 0 0 6 0zm-4 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM19 36h22a1 1 0 0 0 0-2H19a1 1 0 0 0 0 2zM12.168 46.445l-3.323 4.986-1.138-1.138a1 1 0 0 0-1.414 1.414l2 2A1 1 0 0 0 9 54c.033 0 .065 0 .1-.005a1 1 0 0 0 .733-.44l4-6a1 1 0 0 0-1.664-1.11z",
    fill: "#81A63D",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailableCourses);
export default __webpack_public_path__ + "static/media/availableCourses.33b306502c18b449fd16ce6c84f4dc15.svg";
export { ForwardRef as ReactComponent };